import React from 'react';
import { useNavigate } from 'react-router-dom';

const Forbidden: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="hero-gradient">
      <div className="hero-card">
        <div className="hero-card__body text-center">
          <div className="empty-state__icon"><span className="material-symbols-outlined icon-xl">block</span></div>
          <h1 className="page-title mb-4" style={{ color: 'var(--color-danger)' }}>
            403 Forbidden
          </h1>
          <h2 className="font-medium mb-6" style={{ fontSize: 'var(--text-xl)' }}>
            アクセス権限がありません
          </h2>
          <p className="text-muted mb-8" style={{ lineHeight: 1.6 }}>
            このページへのアクセスは管理者のみに許可されています。
            <br />
            管理者権限が必要な場合は、システム管理者にお問い合わせください。
          </p>
          <button
            className="btn btn--primary"
            onClick={() => navigate('/files')}
          >
            ファイル一覧に戻る
          </button>
        </div>
      </div>
    </div>
  );
};

export default Forbidden;
